(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const mensaje = document.getElementById(location.hash.slice(1))?.querySelector('.articulo__comentario-mensaje');
    if (!mensaje) return;

    // Mismo patrón que sections/boletin.liquid: el navegador desplaza a la
    // sección con el fragmento de la URL y, como su destino no es enfocable
    // (el <form>), a veces quita el foco puesto por script poco después. Se
    // reafirma una sola vez, solo si esa es la firma exacta del reinicio del
    // navegador (sin relatedTarget y a <body>), nunca si el foco se movió a
    // otro elemento. El listener se desarma al segundo.
    const controlEnfoque = new AbortController();
    mensaje.focus();
    mensaje.addEventListener(
      'focusout',
      (evento) => {
        if (!evento.relatedTarget && document.activeElement === document.body) {
          mensaje.focus();
        }
      },
      { once: true, signal: controlEnfoque.signal }
    );
    setTimeout(() => controlEnfoque.abort(), 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boletin"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mensajeBoletin = document.getElementById(location.hash.slice(1))?.querySelector('.boletin__mensaje');
    if (!mensajeBoletin) return;

    // El navegador desplaza a la sección con el fragmento de la URL y, como su
    // destino no es enfocable (el <form>), a veces quita el foco puesto por
    // script poco después (confirmado: entre 10 y 60ms tras cargar, a <body>
    // y sin relatedTarget). Se reafirma una sola vez, pero solo si esa es la
    // firma exacta del reinicio del navegador: nunca si el foco se movió a
    // otro elemento (por ejemplo, un Tab real de quien usa el teclado). El
    // listener se desarma al segundo para no interferir con nada posterior.
    const controlEnfoque = new AbortController();
    mensajeBoletin.focus();
    mensajeBoletin.addEventListener(
      'focusout',
      (evento) => {
        if (!evento.relatedTarget && document.activeElement === document.body) {
          mensajeBoletin.focus();
        }
      },
      { once: true, signal: controlEnfoque.signal }
    );
    setTimeout(() => controlEnfoque.abort(), 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boton-whatsapp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-boton-whatsapp')) {
    customElements.define(
      'delora-boton-whatsapp',
      class extends HTMLElement {
        #botonToggle = null;
        #botonDirecto = null;
        #widget = null;
        #cerrar = null;
        #tooltip = null;
        #insignia = null;
        #formulario = null;
        #input = null;
        #abortController = null;

        connectedCallback() {
          this.#abortController = new AbortController();
          const { signal } = this.#abortController;

          this.#botonToggle = this.querySelector('[data-boton-toggle]');
          this.#botonDirecto = this.querySelector('[data-boton-directo]');
          this.#widget = this.querySelector('[data-widget]');
          this.#cerrar = this.querySelector('[data-cerrar]');
          this.#tooltip = this.querySelector('[data-tooltip]');
          this.#insignia = this.querySelector('[data-insignia]');
          this.#formulario = this.querySelector('[data-formulario-chat]');
          this.#input = this.querySelector('[data-input-chat]');

          // Poner hora actual en la burbuja del agente
          const horaEl = this.querySelector('[data-hora-agente]');
          if (horaEl) {
            const ahora = new Date();
            horaEl.textContent = ahora.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          }

          // Botón Toggle para abrir/cerrar widget
          if (this.#botonToggle && this.#widget) {
            this.#botonToggle.addEventListener('click', () => this.#toggle(), { signal });
          }

          // Botón cerrar widget
          if (this.#cerrar) {
            this.#cerrar.addEventListener('click', () => this.#cerrarWidget(), { signal });
          }

          // Cerrar tooltip al hacer clic en su X
          const cerrarTooltip = this.querySelector('[data-tooltip-cerrar]');
          if (cerrarTooltip && this.#tooltip) {
            cerrarTooltip.addEventListener('click', (e) => {
              e.stopPropagation();
              this.#tooltip.remove();
            }, { signal });
          }

          // Acciones de contexto (botón preguntar por producto / colección / carrito)
          this.addEventListener('click', (evento) => {
            const btnAccion = evento.target.closest('[data-accion-contexto]');
            if (btnAccion) {
              evento.preventDefault();
              const tipo = btnAccion.dataset.accionContexto;
              this.#enviarContextual(tipo);
              return;
            }

            // Chips de preguntas rápidas
            const chipPregunta = evento.target.closest('[data-pregunta]');
            if (chipPregunta) {
              evento.preventDefault();
              const textoPregunta = chipPregunta.dataset.pregunta;
              this.#enviarPreguntaRapida(textoPregunta);
              return;
            }
          }, { signal });

          // Formulario de mensaje libre
          if (this.#formulario && this.#input) {
            this.#formulario.addEventListener('submit', (evento) => {
              evento.preventDefault();
              const texto = this.#input.value.trim();
              if (!texto) return;
              this.#enviarMensajeLibre(texto);
              this.#input.value = '';
            }, { signal });
          }

          // Cerrar con tecla Escape
          document.addEventListener('keydown', (evento) => {
            if (evento.key === 'Escape' && this.#widget && !this.#widget.hidden) {
              this.#cerrarWidget();
            }
          }, { signal });

          // Cerrar al hacer clic fuera del widget
          document.addEventListener('click', (evento) => {
            if (
              this.#widget &&
              !this.#widget.hidden &&
              !this.contains(evento.target)
            ) {
              this.#cerrarWidget();
            }
          }, { signal });

          // Escuchar cambios de variante en la página de producto para actualizar precio y mensaje dinámicamente
          if (this.dataset.plantilla === 'product') {
            document.addEventListener('change', (evento) => this.#alCambiarVariante(evento), { signal });
            window.addEventListener('popstate', () => this.#alCambiarUrl(), { signal });
          }
        }

        disconnectedCallback() {
          this.#abortController?.abort();
        }

        #toggle() {
          if (!this.#widget) return;
          if (this.#widget.hidden) {
            this.#abrirWidget();
          } else {
            this.#cerrarWidget();
          }
        }

        #abrirWidget() {
          if (!this.#widget) return;
          this.#widget.hidden = false;
          // Quitar tooltip e insignia al abrir
          if (this.#tooltip) this.#tooltip.style.display = 'none';
          if (this.#insignia) this.#insignia.style.display = 'none';

          // Animación suave
          requestAnimationFrame(() => {
            this.#widget.classList.add('abierto');
            this.#widget.setAttribute('aria-hidden', 'false');
            this.#botonToggle?.setAttribute('aria-expanded', 'true');
            this.#input?.focus();
          });
        }

        #cerrarWidget() {
          if (!this.#widget) return;
          this.#widget.classList.remove('abierto');
          this.#widget.setAttribute('aria-hidden', 'true');
          this.#botonToggle?.setAttribute('aria-expanded', 'false');
          setTimeout(() => {
            this.#widget.hidden = true;
            this.#botonToggle?.focus();
          }, 280);
        }

        #obtenerTelefono() {
          return this.dataset.telefono || '';
        }

        #abrirWhatsapp(mensaje) {
          const telefono = this.#obtenerTelefono();
          const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;
          window.open(url, '_blank', 'noopener,noreferrer');
        }

        #enviarContextual(tipo) {
          let mensaje = '';
          const url = this.dataset.urlActual || window.location.href;

          if (tipo === 'producto') {
            const plantilla = this.dataset.mensajeProducto || '¡Hola! Quisiera saber más información sobre su producto {producto} ({precio}). Enlace: {url}';
            mensaje = plantilla
              .replace('{producto}', this.dataset.productoTitulo || '')
              .replace('{variante}', this.dataset.productoVariante || '')
              .replace('{precio}', this.dataset.productoPrecio || '')
              .replace('{url}', url);
          } else if (tipo === 'coleccion') {
            const plantilla = this.dataset.mensajeColeccion || '¡Hola! Estoy viendo la colección {coleccion} y quisiera recibir asesoría. Enlace: {url}';
            mensaje = plantilla
              .replace('{coleccion}', this.dataset.coleccionTitulo || '')
              .replace('{url}', url);
          } else if (tipo === 'carrito') {
            const plantilla = this.dataset.mensajeCarrito || '¡Hola! Tengo dudas sobre mi compra en el carrito ({total}). Enlace: {url}';
            mensaje = plantilla
              .replace('{total}', this.dataset.carritoTotal || '')
              .replace('{articulos}', this.dataset.carritoArticulos || '')
              .replace('{url}', url);
          } else {
            mensaje = this.dataset.mensajeGeneral || '¡Hola! Quisiera más información sobre la tienda y sus productos.';
          }

          this.#abrirWhatsapp(mensaje);
        }

        #enviarPreguntaRapida(pregunta) {
          const plantilla = this.dataset.plantilla;
          const url = this.dataset.urlActual || window.location.href;
          let sufijoContexto = '';

          if (plantilla === 'product' && this.dataset.productoTitulo) {
            sufijoContexto = `\n\n(Consulta sobre: ${this.dataset.productoTitulo} - ${url})`;
          } else if (plantilla === 'collection' && this.dataset.coleccionTitulo) {
            sufijoContexto = `\n\n(Viendo colección: ${this.dataset.coleccionTitulo} - ${url})`;
          }

          const mensajeCompleto = `${pregunta}${sufijoContexto}`;
          this.#abrirWhatsapp(mensajeCompleto);
        }

        #enviarMensajeLibre(textoUsuario) {
          const plantilla = this.dataset.plantilla;
          const url = this.dataset.urlActual || window.location.href;
          let sufijoContexto = '';

          if (plantilla === 'product' && this.dataset.productoTitulo) {
            sufijoContexto = `\n\n(Producto de referencia: ${this.dataset.productoTitulo} - ${this.dataset.productoPrecio || ''}\n${url})`;
          } else if (plantilla === 'collection' && this.dataset.coleccionTitulo) {
            sufijoContexto = `\n\n(Colección de referencia: ${this.dataset.coleccionTitulo} - ${url})`;
          }

          const mensajeCompleto = `¡Hola! Tengo una consulta:\n${textoUsuario}${sufijoContexto}`;
          this.#abrirWhatsapp(mensajeCompleto);
        }

        #alCambiarVariante(evento) {
          const campoId = evento.target.closest('input[name="id"]:checked, select[name="id"]');
          if (!campoId) return;

          // Si el tema tiene selector de variantes, consultar el precio actualizado en pantalla
          setTimeout(() => {
            const precioEl = document.querySelector('.producto-principal__precio, [data-region="precio"]');
            if (precioEl) {
              const precioTexto = precioEl.textContent.trim().replace(/\s+/g, ' ');
              this.dataset.productoPrecio = precioTexto;
              const widgetPrecio = this.querySelector('[data-producto-precio-el]');
              if (widgetPrecio) widgetPrecio.textContent = precioTexto;
            }

            // Actualizar variante seleccionada si hay radio o select
            const opcionSeleccionada = campoId instanceof HTMLSelectElement
              ? campoId.options[campoId.selectedIndex]?.text
              : campoId.nextElementSibling?.textContent?.trim();

            if (opcionSeleccionada) {
              this.dataset.productoVariante = opcionSeleccionada;
              const widgetVariante = this.querySelector('[data-producto-variante-el]');
              if (widgetVariante) widgetVariante.textContent = opcionSeleccionada;
            }

            this.dataset.urlActual = window.location.href;
          }, 150);
        }

        #alCambiarUrl() {
          this.dataset.urlActual = window.location.href;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buscador-afinidad"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-buscador-afinidad')) {
    customElements.define(
      'delora-buscador-afinidad',
      class extends HTMLElement {
        #pasos = [];
        #actual = 0;
        #respuestas = [];
        #controlador;
        #peticion;
        #partes;

        connectedCallback() {
          this.#pasos = [...this.querySelectorAll('[data-paso]')].filter((paso) => paso.querySelector('[data-opcion]'));
          if (this.#pasos.length === 0) return;

          this.#partes = {
            cabeceras: [...this.querySelectorAll('[data-cabecera]')],
            atras: this.querySelector('[data-atras]'),
            progreso: this.querySelector('[data-progreso]'),
            barra: this.querySelector('[data-barra]'),
            resultado: this.querySelector('[data-resultado]'),
            tuFamilia: this.querySelector('[data-tu-familia]'),
            familia: this.querySelector('[data-familia]'),
            tarjetas: this.querySelector('[data-tarjetas]'),
            vacio: this.querySelector('[data-vacio]'),
            ver: this.querySelector('[data-ver]'),
            estado: this.querySelector('[data-estado]'),
          };
          if (Object.values(this.#partes).some((parte) => !parte)) return;

          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          for (const opcion of this.querySelectorAll('[data-opcion]')) opcion.setAttribute('role', 'button');
          this.dataset.listo = '';

          this.addEventListener('click', (evento) => this.#alPulsar(evento), { signal });
          this.addEventListener('keydown', (evento) => this.#alTeclear(evento), { signal });
          this.addEventListener(
            'shopify:block:select',
            (evento) => {
              const indice = this.#pasos.indexOf(evento.target.closest('[data-paso]'));
              if (indice !== -1) this.#ir(indice, false);
            },
            { signal }
          );

          this.#respuestas = [];
          this.#ir(0, false);
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#peticion?.abort();
        }

        #alPulsar(evento) {
          const opcion = evento.target.closest('[data-opcion]');
          if (opcion) {
            if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
            const indice = this.#pasos.indexOf(opcion.closest('[data-paso]'));
            if (indice === -1) return;
            evento.preventDefault();
            this.#elegir(indice, opcion);
            return;
          }

          if (evento.target.closest('[data-atras]')) {
            this.#ir(this.#actual - 1);
            return;
          }

          if (evento.target.closest('[data-repetir]')) this.#repetir();
        }

        #alTeclear(evento) {
          if (evento.key !== ' ') return;
          const opcion = evento.target.closest('[data-opcion]');
          if (!opcion) return;
          evento.preventDefault();
          if (evento.repeat) return;
          opcion.click();
        }

        #ir(indice, enfocar = true) {
          const paso = this.#pasos[indice];
          if (!paso) return;

          this.#peticion?.abort();
          this.#actual = indice;

          const numero = String(indice + 1);
          const total = String(this.#pasos.length);
          const rellenar = (plantilla) => (plantilla ?? '').replace('[actual]', numero).replace('[total]', total);

          for (const otro of this.#pasos) otro.toggleAttribute('data-activo', otro === paso);
          for (const cabecera of this.#partes.cabeceras) cabecera.hidden = false;
          this.#partes.resultado.hidden = true;
          this.#partes.atras.classList.toggle('buscador-afinidad__atras--oculto', indice === 0);
          this.#partes.progreso.textContent = rellenar(this.dataset.textoProgreso);
          this.#partes.barra.style.transform = `scaleX(${(indice + 1) / this.#pasos.length})`;

          const numeroPaso = paso.querySelector('[data-numero-paso]');
          if (numeroPaso) numeroPaso.textContent = `${rellenar(this.dataset.textoPaso)} `;

          this.#anunciar('');
          if (enfocar) paso.querySelector('[data-titulo-paso]')?.focus();
        }

        #elegir(indice, opcion) {
          this.#respuestas[indice] = {
            principal: opcion.dataset.principal ?? '',
            secundaria: opcion.dataset.secundaria ?? '',
            ocasion: opcion.dataset.ocasion ?? '',
          };

          if (indice < this.#pasos.length - 1) {
            this.#ir(indice + 1);
            return;
          }

          this.#resultado();
        }

        #ranking() {
          const puntos = new Map();
          const orden = [];
          const sumar = (familia, valor) => {
            if (!familia) return;
            if (!puntos.has(familia)) {
              puntos.set(familia, 0);
              orden.push(familia);
            }
            puntos.set(familia, puntos.get(familia) + valor);
          };

          for (const respuesta of this.#respuestas) {
            if (!respuesta) continue;
            sumar(respuesta.principal, 3);
            sumar(respuesta.secundaria, 1);
          }

          return [...orden].sort((a, b) => puntos.get(b) - puntos.get(a) || orden.indexOf(a) - orden.indexOf(b));
        }

        #ocasion() {
          let ocasion = null;
          for (const respuesta of this.#respuestas) {
            if (respuesta?.ocasion && respuesta.ocasion !== 'cualquiera') ocasion = respuesta.ocasion;
          }
          return ocasion;
        }

        #url(familia, ocasion) {
          const url = new URL(this.dataset.urlColeccion ?? '', location.origin);
          url.searchParams.set('filter.p.m.delora.familia', familia);
          if (ocasion) url.searchParams.set('filter.p.m.delora.ocasion', ocasion);
          return url;
        }

        async #pedir(url, signal) {
          const direccion = new URL(url);
          direccion.searchParams.set('section_id', 'grilla-productos');

          const respuesta = await fetch(direccion, { signal });
          if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
          const html = await respuesta.text();
          signal.throwIfAborted();

          const documento = new DOMParser().parseFromString(html, 'text/html');
          const contenedor = documento.querySelector('[data-total]');
          if (!contenedor) throw new Error('Respuesta sin grilla');

          return { url, documento, total: Number(contenedor.dataset.total) || 0 };
        }

        async #resultado() {
          this.#peticion?.abort();
          const peticion = new AbortController();
          this.#peticion = peticion;

          const paso = this.#pasos[this.#actual];
          paso.setAttribute('aria-busy', 'true');
          this.#anunciar(this.dataset.textoBuscando ?? '');

          const familias = this.#ranking();
          const ocasion = this.#ocasion();

          try {
            for (const familia of familias) {
              for (const filtro of ocasion ? [ocasion, null] : [null]) {
                const respuesta = await this.#pedir(this.#url(familia, filtro), peticion.signal);
                if (respuesta.total > 0) {
                  this.#mostrar(familia, respuesta);
                  return;
                }
              }
            }
            this.#mostrar(null);
          } catch (error) {
            if (error.name === 'AbortError') return;
            console.error(error);
            location.assign(familias.length > 0 ? this.#url(familias[0], null) : (this.dataset.urlColeccion ?? ''));
          } finally {
            if (this.#peticion === peticion) {
              this.#peticion = undefined;
              paso.removeAttribute('aria-busy');
            }
          }
        }

        #mostrar(familia, respuesta) {
          const { cabeceras, resultado, tuFamilia, familia: nombre, tarjetas, vacio, ver } = this.#partes;
          const encontrada = Boolean(familia && respuesta);

          for (const paso of this.#pasos) paso.removeAttribute('data-activo');
          for (const cabecera of cabeceras) cabecera.hidden = true;
          resultado.hidden = false;

          tuFamilia.hidden = !encontrada;
          nombre.hidden = !encontrada;
          tarjetas.hidden = !encontrada;
          vacio.hidden = encontrada;

          if (!encontrada) {
            nombre.textContent = '';
            tarjetas.replaceChildren();
            ver.setAttribute('href', this.dataset.urlColeccion ?? '');
            ver.textContent = this.dataset.textoVerColeccion ?? '';
            this.#anunciar('');
            vacio.focus();
            return;
          }

          const elementos = [...respuesta.documento.querySelectorAll('li.grilla-productos__elemento')].slice(0, 3);
          tarjetas.replaceChildren(...elementos.map((elemento) => document.importNode(elemento, true)));

          nombre.textContent = familia;
          ver.setAttribute('href', `${respuesta.url.pathname}${respuesta.url.search}`);
          ver.textContent =
            respuesta.total === 1
              ? (this.dataset.textoVerUna ?? '')
              : (this.dataset.textoVerVarias ?? '').replace('[cantidad]', String(respuesta.total));

          this.#anunciar((this.dataset.textoAnuncio ?? '').replace('[familia]', familia));
          nombre.focus();
        }

        #repetir() {
          this.#respuestas = [];
          this.#ir(0);
        }

        #anunciar(texto) {
          this.#partes.estado.textContent = texto;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabecera"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-menu-movil')) {
    customElements.define(
      'delora-menu-movil',
      class extends HTMLElement {
        #controlador;
        #observador;

        connectedCallback() {
          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          this.#observarAltura();

          const dialogo = this.querySelector('dialog');
          if (!dialogo) return;

          if (!('command' in HTMLButtonElement.prototype)) {
            for (const boton of this.querySelectorAll('button[commandfor]')) {
              boton.addEventListener('click', () => this.#ejecutar(boton), { signal });
            }
          }

          dialogo.addEventListener(
            'click',
            (evento) => {
              if (evento.target instanceof Element && evento.target.closest('a')) dialogo.close();
            },
            { signal }
          );

          matchMedia('(min-width: 64rem)').addEventListener(
            'change',
            (evento) => {
              if (evento.matches) dialogo.close();
            },
            { signal }
          );
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#observador?.disconnect();
        }

        #observarAltura() {
          const cabecera = this.closest('.cabecera--fija');
          if (!cabecera) return;

          const objetivo = cabecera.closest('.shopify-section') ?? cabecera;
          this.#observador = new ResizeObserver(() => {
            const alto = Math.round(objetivo.getBoundingClientRect().height);
            document.documentElement.style.setProperty('--altura-cabecera', `${alto}px`);
          });
          this.#observador.observe(objetivo);
        }

        #ejecutar(boton) {
          const dialogo = document.getElementById(boton.getAttribute('commandfor'));
          if (!(dialogo instanceof HTMLDialogElement)) return;

          const comando = boton.getAttribute('command');
          if (comando === 'show-modal' && !dialogo.open) dialogo.showModal();
          if (comando === 'close') dialogo.close();
        }
      }
    );
  }

  if (!customElements.get('delora-busqueda-predictiva')) {
    customElements.define(
      'delora-busqueda-predictiva',
      class extends HTMLElement {
        #controlador;
        #peticion;
        #espera;
        #enlace;
        #dialogo;
        #campo;
        #resultados;
        #estado;

        connectedCallback() {
          this.#enlace = this.querySelector(':scope > a');
          this.#dialogo = this.querySelector(':scope > dialog');
          this.#campo = this.#dialogo?.querySelector('[role="combobox"]');
          this.#resultados = this.#dialogo?.querySelector('.cabecera__resultados');
          this.#estado = this.#dialogo?.querySelector('[role="status"]');
          if (!this.#enlace || !this.#dialogo || !this.#campo || !this.#resultados || !this.#estado) return;

          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          this.#enlace.addEventListener(
            'click',
            (evento) => {
              if (evento.ctrlKey || evento.metaKey || evento.shiftKey) return;
              evento.preventDefault();
              if (!this.#dialogo.open) this.#dialogo.showModal();
              this.#campo.focus();
            },
            { signal }
          );

          this.#dialogo
            .querySelector('button[data-cerrar]')
            ?.addEventListener('click', () => this.#dialogo.close(), { signal });

          this.#dialogo.addEventListener(
            'close',
            () => {
              this.#activar(-1);
              this.#enlace.focus();
            },
            { signal }
          );

          this.#campo.addEventListener('input', () => this.#programar(), { signal });
          this.#campo.addEventListener('keydown', (evento) => this.#teclado(evento), { signal });
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#cancelar();
        }

        #programar() {
          this.#cancelar();
          this.#activar(-1);

          const terminos = this.#campo.value.trim();
          if (terminos.length < 2) {
            this.#mostrar('');
            return;
          }

          this.#espera = setTimeout(() => this.#buscar(terminos), 300);
        }

        #cancelar() {
          clearTimeout(this.#espera);
          this.#peticion?.abort();
        }

        async #buscar(terminos) {
          this.#peticion?.abort();
          this.#peticion = new AbortController();
          const { signal } = this.#peticion;
          const url = `${this.dataset.url}?q=${encodeURIComponent(terminos)}&resources[type]=product,collection,page&resources[limit]=6&section_id=busqueda-predictiva`;

          try {
            const respuesta = await fetch(url, { signal });
            if (!respuesta.ok) {
              this.#mostrar('');
              return;
            }

            const html = await respuesta.text();
            if (signal.aborted) return;

            const seccion = new DOMParser()
              .parseFromString(html, 'text/html')
              .getElementById('shopify-section-busqueda-predictiva');
            this.#mostrar(seccion?.innerHTML ?? '');
            this.#enlazarVerTodo(terminos);
          } catch {
            if (!signal.aborted) this.#mostrar('');
          }
        }

        #enlazarVerTodo(terminos) {
          const enlace = this.#resultados.querySelector('a[data-ver-todo]');
          if (!enlace || !this.dataset.urlBusqueda) return;

          const destino = new URL(this.dataset.urlBusqueda, window.location.origin);
          destino.searchParams.set('q', terminos);
          destino.searchParams.set('type', 'product');
          destino.searchParams.set('options[prefix]', 'last');
          enlace.href = destino.href;
        }

        #mostrar(html) {
          this.#resultados.innerHTML = html;
          this.#campo.removeAttribute('aria-activedescendant');

          const lista = this.#resultados.querySelector('[role="listbox"]');
          this.#campo.setAttribute('aria-expanded', lista ? 'true' : 'false');

          if (!html.trim()) {
            this.#estado.textContent = '';
            return;
          }

          const cantidad = lista?.dataset.cantidad ?? '0';
          this.#estado.textContent = (this.dataset.textoResultados ?? '').replace('[cantidad]', cantidad);
        }

        #opciones() {
          return [...this.#resultados.querySelectorAll('[role="option"]')];
        }

        #activar(indice) {
          const opciones = this.#opciones();
          for (const [posicion, opcion] of opciones.entries()) {
            if (posicion === indice) opcion.setAttribute('aria-selected', 'true');
            else opcion.removeAttribute('aria-selected');
          }

          const activa = opciones[indice];
          if (!activa) {
            this.#campo.removeAttribute('aria-activedescendant');
            return;
          }

          this.#campo.setAttribute('aria-activedescendant', activa.id);
          activa.scrollIntoView({ block: 'nearest' });
        }

        #teclado(evento) {
          if (evento.isComposing) return;

          const opciones = this.#opciones();
          const actual = opciones.findIndex((opcion) => opcion.getAttribute('aria-selected') === 'true');

          if (evento.key === 'ArrowDown' || evento.key === 'ArrowUp') {
            if (opciones.length === 0) return;
            evento.preventDefault();
            const paso = evento.key === 'ArrowDown' ? 1 : -1;
            const origen = actual === -1 && paso === -1 ? opciones.length : actual;
            this.#activar((origen + paso + opciones.length) % opciones.length);
            return;
          }

          if (evento.key === 'Enter') {
            const activa = opciones[actual];
            if (!activa) return;
            evento.preventDefault();
            window.location.assign(activa.href);
            return;
          }

          if (evento.key !== 'Escape') return;
          evento.preventDefault();

          if (this.#resultados.childElementCount > 0) {
            this.#cancelar();
            this.#mostrar('');
            return;
          }

          this.#dialogo.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-cajon"]) return;
  try {
    
  if (!customElements.get('delora-carrito-cajon')) {
    customElements.define(
      'delora-carrito-cajon',
      class extends HTMLElement {
        #controlador;
        #disparador = null;
        #temporizador = 0;

        connectedCallback() {
          this.#controlador?.abort();
          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          const dialogo = this.#dialogo();
          if (!dialogo) return;

          document.addEventListener('click', (evento) => this.#alPulsarDocumento(evento), { signal });
          dialogo.addEventListener('click', (evento) => this.#alPulsarDialogo(evento), { signal });
          dialogo.addEventListener('close', () => this.#alCerrar(), { signal });
          document.addEventListener('delora:carrito-actualizado', (evento) => this.#alActualizar(evento), { signal });

          if (window.Shopify?.designMode) {
            document.addEventListener(
              'shopify:section:select',
              (evento) => {
                if (evento.detail?.sectionId === this.dataset.seccion) this.#abrir(null);
              },
              { signal }
            );
            document.addEventListener(
              'shopify:section:deselect',
              (evento) => {
                if (evento.detail?.sectionId === this.dataset.seccion) dialogo.close();
              },
              { signal }
            );
          }
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          clearTimeout(this.#temporizador);
        }

        #dialogo() {
          const dialogo = this.querySelector('[data-cajon]');
          return dialogo instanceof HTMLDialogElement && typeof dialogo.showModal === 'function' ? dialogo : null;
        }

        #alPulsarDocumento(evento) {
          if (evento.defaultPrevented || evento.button !== 0) return;
          if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
          if (!(evento.target instanceof Element)) return;

          const enlace = evento.target.closest('[data-abrir-carrito]');
          if (!enlace) return;

          evento.preventDefault();
          this.#abrir(enlace);
        }

        // Respaldo de closedby="any": solo cierra con un clic fuera de la caja del diálogo (el fondo)
        #alPulsarDialogo(evento) {
          const dialogo = evento.currentTarget;
          if (!(dialogo instanceof HTMLDialogElement) || !(evento.target instanceof Element)) return;

          const cerrar = evento.target.closest('[data-cerrar]');
          if (cerrar && dialogo.contains(cerrar)) {
            dialogo.close();
            return;
          }
          if (evento.target !== dialogo) return;

          const caja = dialogo.getBoundingClientRect();
          const dentro =
            evento.clientX >= caja.left &&
            evento.clientX <= caja.right &&
            evento.clientY >= caja.top &&
            evento.clientY <= caja.bottom;
          if (!dentro) dialogo.close();
        }

        // El enlace de la cabecera se sustituye tras cada cambio: si el disparador era ese enlace, el foco va al nuevo
        #alCerrar() {
          clearTimeout(this.#temporizador);
          const anuncio = this.querySelector('[data-anuncio]');
          if (anuncio) anuncio.textContent = '';

          let destino = this.#disparador;
          this.#disparador = null;
          if (destino && !destino.isConnected && destino.matches('[data-carrito-cabecera]')) {
            destino = document.querySelector('a[data-carrito-cabecera]');
          }
          if (destino instanceof HTMLElement && destino.isConnected) destino.focus();
        }

        #alActualizar(evento) {
          const { secciones, cantidad, abrir, anuncio } = evento.detail ?? {};

          let total = Number.isInteger(cantidad) ? cantidad : null;
          const html = secciones?.[this.dataset.seccion ?? ''];
          if (total === null && html) {
            const cuenta = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cuenta]');
            const leido = Number.parseInt(cuenta?.getAttribute('data-cuenta') ?? '', 10);
            if (Number.isInteger(leido)) total = leido;
          }
          if (total !== null) this.#pintarCuenta(total);

          if (!abrir) return;
          this.#abrir(document.activeElement);
          this.#anunciar(anuncio);
        }

        #pintarCuenta(total) {
          const cuenta = this.querySelector('[data-cuenta]');
          if (!cuenta) return;
          cuenta.dataset.cuenta = String(total);
          cuenta.textContent = `(${total})`;
        }

        #abrir(disparador) {
          const dialogo = this.#dialogo();
          if (!dialogo || !dialogo.isConnected) return;

          if (!dialogo.open) {
            this.#disparador = disparador instanceof HTMLElement && disparador !== document.body ? disparador : null;
            this.#reservarBarra();
            dialogo.showModal();
          }
          const destino = this.querySelector('[data-titulo]') ?? dialogo.querySelector('[data-linea] a[href]');
          if (destino instanceof HTMLElement) destino.focus();
        }

        // Al bloquear el desplazamiento desaparece la barra clásica: su ancho, medido antes, pasa a relleno de `html` para
        // que la página no se mueva. `scrollbar-gutter` no sirve: Chrome no pinta el cajón fijo sobre el hueco reservado
        #reservarBarra() {
          const raiz = document.documentElement;
          const ancho = Math.max(0, window.innerWidth - raiz.clientWidth);
          raiz.style.setProperty('--carrito-cajon-barra', `${ancho}px`);
        }

        // La región acaba de mostrarse con el diálogo: el texto entra un momento después para que se anuncie
        #anunciar(texto) {
          const region = this.querySelector('[data-anuncio]');
          if (!region || !texto) return;

          clearTimeout(this.#temporizador);
          region.textContent = '';
          this.#temporizador = setTimeout(() => {
            region.textContent = texto;
          }, 150);
        }
      }
    );
  }

  if (!customElements.get('delora-agregar-carrito')) {
    customElements.define(
      'delora-agregar-carrito',
      class extends HTMLElement {
        #controlador;
        #enCurso = false;
        #pulsadoFuera = false;

        connectedCallback() {
          this.#controlador?.abort();
          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          this.addEventListener('submit', (evento) => this.#alEnviar(evento), { signal });
          this.addEventListener('keydown', (evento) => this.#alTeclear(evento), { signal });
          this.addEventListener('change', (evento) => this.#alCambiar(evento), { signal });
          this.addEventListener('focusout', (evento) => this.#alSalirFoco(evento), { signal });
          this.addEventListener('click', (evento) => this.#alPulsar(evento), { capture: true, signal });
          this.addEventListener('toggle', (evento) => this.#alAlternar(evento), { capture: true, signal });
          document.addEventListener('pointerdown', (evento) => this.#alPresionarFuera(evento), { capture: true, signal });
        }

        disconnectedCallback() {
          this.#controlador?.abort();
        }

        // Otro tamaño en la ficha: el aviso del intento anterior ya no aplica
        #alCambiar(evento) {
          if (evento.target instanceof Element && evento.target.getAttribute('name') === 'id') this.#mostrarError('');
        }

        // Al cerrarse el menú de tamaños, su aviso deja de aplicar: si no, mantiene visible el botón y reaparece al
        // reabrir. `toggle` no burbujea, por eso se escucha en captura; con el menú abierto el aviso se conserva
        #alAlternar(evento) {
          const menu = evento.target;
          if (!(menu instanceof HTMLDetailsElement) || menu.open || !this.contains(menu)) return;
          const aviso = menu.querySelector('[data-error-agregar]');
          if (aviso) aviso.textContent = '';
        }

        // El menú de tamaños se cierra al pulsar fuera o al salir con Tab, sin mover el foco. Los clics los resuelve
        // `pointerdown`: un clic dentro del panel en algo no enfocable (o en un botón, en Safari) lleva el foco a un
        // ancestro enfocable, como `main[tabindex="-1"]`; ese `focusout` no cierra (cerrar ahí tumba Chrome)
        #alPresionarFuera(evento) {
          this.#pulsadoFuera = !(evento.target instanceof Node && this.contains(evento.target));
          const menu = this.querySelector('details[open]');
          if (!menu || (evento.target instanceof Node && menu.contains(evento.target))) return;
          menu.open = false;
        }

        // Con ratón, el botón rápido oculto no recibe pulsaciones (pointer-events: none). Pero en un equipo con ratón y
        // pantalla táctil, un toque activa antes el :hover de la tarjeta y el clic llega al botón ya visible: si la
        // pulsación empezó fuera, ese clic se descarta. Los clics de teclado (`detail` 0) no pasan por `pointerdown`
        #alPulsar(evento) {
          const pulsadoFuera = this.#pulsadoFuera;
          this.#pulsadoFuera = false;
          if (!pulsadoFuera || evento.detail === 0) return;
          evento.preventDefault();
          evento.stopImmediatePropagation();
        }

        #alSalirFoco(evento) {
          const destino = evento.relatedTarget;
          if (!(evento.target instanceof Element) || !(destino instanceof Node)) return;
          const menu = evento.target.closest('details[open]');
          if (!menu || !this.contains(menu) || menu.contains(destino) || destino.contains(menu)) return;
          menu.open = false;
        }

        // Sin cajón (o sin showModal), el formulario se envía como siempre y Shopify lleva al carrito
        #cajon() {
          const cajon = document.querySelector('delora-carrito-cajon');
          const dialogo = cajon?.querySelector('[data-cajon]');
          if (!(dialogo instanceof HTMLDialogElement) || typeof dialogo.showModal !== 'function') return null;
          return cajon;
        }

        #alEnviar(evento) {
          const formulario = evento.target;
          if (!(formulario instanceof HTMLFormElement) || evento.defaultPrevented) return;

          const cajon = this.#cajon();
          if (!cajon) return;

          evento.preventDefault();
          const boton = evento.submitter instanceof HTMLElement ? evento.submitter : null;
          if (this.#enCurso || this.#desactivado(formulario, boton)) return;

          this.#agregar(formulario, boton, cajon);
        }

        #alTeclear(evento) {
          if (evento.key !== 'Escape' || evento.isComposing || !(evento.target instanceof Element)) return;

          const menu = evento.target.closest('details[open]');
          if (!menu || !this.contains(menu)) return;

          evento.preventDefault();
          this.#cerrarMenu(menu);
        }

        #cerrarMenu(menu) {
          menu.open = false;
          menu.querySelector(':scope > summary')?.focus();
        }

        #desactivado(formulario, boton) {
          const inactivo = (elemento) =>
            elemento instanceof Element && elemento.matches(':disabled, [aria-disabled="true"]');

          if (inactivo(boton) || formulario.matches('[aria-disabled="true"]')) return true;
          if (!boton && inactivo(formulario.querySelector('[type="submit"]'))) return true;
          return Boolean(
            formulario.querySelector(
              'input[name="id"]:checked:is(:disabled, [aria-disabled="true"]), select[name="id"] option:checked:disabled'
            )
          );
        }

        #datos(formulario, boton) {
          let datos;
          try {
            datos = boton ? new FormData(formulario, boton) : new FormData(formulario);
          } catch {
            datos = new FormData(formulario);
          }
          const nombre = boton?.getAttribute('name');
          if (nombre && !datos.has(nombre)) datos.append(nombre, boton.getAttribute('value') ?? '');
          return datos;
        }

        #idCabecera() {
          return document
            .querySelector('[data-carrito-cabecera]')
            ?.closest('.shopify-section')
            ?.id.replace(/^shopify-section-/, '');
        }

        #ids(cajon, cabecera) {
          const ids = new Set([cajon.dataset.seccion]);
          for (const carrito of document.querySelectorAll('delora-carrito[data-seccion]')) {
            ids.add(carrito.dataset.seccion);
          }
          const lista = [...ids].filter(Boolean).slice(0, cabecera ? 4 : 5);
          if (cabecera) lista.push(cabecera);
          return lista;
        }

        async #agregar(formulario, boton, cajon) {
          const { signal } = this.#controlador;
          const cabecera = this.#idCabecera();
          const ids = this.#ids(cajon, cabecera);
          const antes = this.#cuenta(cajon);
          const datos = this.#datos(formulario, boton);
          datos.set('sections', ids.join(','));
          datos.set('sections_url', window.location.pathname);

          this.#enCurso = true;
          this.setAttribute('aria-busy', 'true');
          boton?.setAttribute('aria-disabled', 'true');
          this.#mostrarError('');

          try {
            let respuesta;
            let json;
            try {
              ({ respuesta, json } = await this.#pedir(
                `${formulario.getAttribute('action') || '/cart/add'}.js`,
                { method: 'POST', headers: { Accept: 'application/json' }, body: datos },
                signal
              ));
            } catch (error) {
              if (signal.aborted) return;
              const red = error?.name !== 'TimeoutError';
              await this.#recuperar({ formulario, boton, cajon, ids, cabecera, antes, red, signal });
              return;
            }
            if (signal.aborted) return;
            json ??= {};

            // Un 422 puede haber agregado parte de lo pedido: se muestra el aviso de Shopify y se resincroniza sin abrir
            if (!respuesta.ok) {
              const aviso = [json.description, json.message].find((texto) => typeof texto === 'string' && texto.trim());
              this.#mostrarError(aviso ?? cajon.dataset.textoError ?? '');
              const secciones = await this.#resincronizar(ids, signal).catch(() => null);
              if (secciones && !signal.aborted) this.#emitir(secciones, { cabecera, cajon, abrir: false });
              return;
            }

            const secciones = json.sections ?? {};
            if (!secciones[cajon.dataset.seccion ?? '']) {
              window.location.assign(cajon.dataset.urlCarrito || '/cart');
              return;
            }
            this.#completar(secciones, { formulario, boton, cabecera, cajon });
          } finally {
            this.#enCurso = false;
            this.removeAttribute('aria-busy');
            boton?.removeAttribute('aria-disabled');
          }
        }

        // Límite de 15 s también para leer el cuerpo. Sin `AbortSignal.any` (Safari < 17.4), a mano: el temporizador se
        // limpia al terminar o al abortar, y una señal ya abortada se propaga en el acto
        #conLimite(signal) {
          const milisegundos = 15000;
          if (typeof AbortSignal.any === 'function' && typeof AbortSignal.timeout === 'function') {
            return { signal: AbortSignal.any([signal, AbortSignal.timeout(milisegundos)]), liberar: () => {} };
          }

          const controlador = new AbortController();
          if (signal.aborted) {
            controlador.abort(signal.reason);
            return { signal: controlador.signal, liberar: () => {} };
          }

          let temporizador = 0;
          const alAbortar = () => {
            clearTimeout(temporizador);
            controlador.abort(signal.reason);
          };
          const liberar = () => {
            clearTimeout(temporizador);
            signal.removeEventListener('abort', alAbortar);
          };
          signal.addEventListener('abort', alAbortar, { once: true });
          temporizador = setTimeout(() => {
            signal.removeEventListener('abort', alAbortar);
            controlador.abort(new DOMException('Tiempo agotado', 'TimeoutError'));
          }, milisegundos);
          return { signal: controlador.signal, liberar };
        }

        async #pedir(url, opciones, signal) {
          const limite = this.#conLimite(signal);
          try {
            const respuesta = await fetch(url, { ...opciones, signal: limite.signal });
            const json = await respuesta.json().catch(() => null);
            return { respuesta, json };
          } finally {
            limite.liberar();
          }
        }

        async #resincronizar(ids, signal) {
          const destino = new URL(window.Shopify?.routes?.root ?? '/', window.location.origin);
          destino.searchParams.set('sections', ids.join(','));
          const { respuesta, json } = await this.#pedir(destino, {}, signal);
          if (!respuesta.ok || !json || typeof json !== 'object') throw new Error(`HTTP ${respuesta.status}`);
          return json;
        }

        // Sin respuesta (red o tiempo agotado) no se sabe si se agregó: lo dice el carrito resincronizado.
        // Si creció, se trata como agregado. Si no, con error de red se envía el formulario como sin JS;
        // con tiempo agotado o sin poder resincronizar, solo el aviso (reenviar podría duplicar).
        async #recuperar({ formulario, boton, cajon, ids, cabecera, antes, red, signal }) {
          const secciones = await this.#resincronizar(ids, signal).catch(() => null);
          if (signal.aborted) return;

          const despues = secciones ? this.#cantidad(secciones[cajon.dataset.seccion ?? ''] ?? '') : null;
          const comparable = antes !== null && despues !== null;
          if (comparable && despues > antes) {
            this.#completar(secciones, { formulario, boton, cabecera, cajon });
            return;
          }
          if (comparable && red) {
            this.#enviarSinJs(formulario, boton);
            return;
          }
          this.#mostrarError(cajon.dataset.textoError ?? '');
        }

        #completar(secciones, { formulario, boton, cabecera, cajon }) {
          this.#prepararFoco(formulario, boton);
          this.#emitir(secciones, { cabecera, cajon, abrir: true });
        }

        #emitir(secciones, { cabecera, cajon, abrir }) {
          this.#sustituirCabecera(cabecera ? secciones[cabecera] : null);
          document.dispatchEvent(
            new CustomEvent('delora:carrito-actualizado', {
              detail: {
                secciones,
                origen: 'agregar',
                abrir,
                anuncio: abrir ? (this.dataset.textoAgregado ?? null) : null,
                cantidad: this.#cantidad(secciones[cajon.dataset.seccion ?? ''] ?? ''),
              },
            })
          );
        }

        // Con tamaños, el menú se cierra y el foco vuelve a su botón; sin él, al botón pulsado (Safari no lo enfoca al hacer clic)
        #prepararFoco(formulario, boton) {
          const menu = boton?.closest('details');
          if (menu && this.contains(menu)) {
            this.#cerrarMenu(menu);
            return;
          }

          const destino = boton?.isConnected ? boton : formulario.querySelector('[type="submit"]');
          if (destino instanceof HTMLElement && document.activeElement !== destino) {
            destino.focus({ preventScroll: true });
          }
        }

        #enviarSinJs(formulario, boton) {
          const nombre = boton?.getAttribute('name');
          if (nombre) {
            const campo = document.createElement('input');
            campo.type = 'hidden';
            campo.name = nombre;
            campo.value = boton.getAttribute('value') ?? '';
            formulario.append(campo);
          }
          formulario.submit();
        }

        #cuenta(raiz) {
          const total = Number.parseInt(raiz.querySelector('[data-cuenta]')?.getAttribute('data-cuenta') ?? '', 10);
          return Number.isInteger(total) ? total : null;
        }

        #cantidad(html) {
          return html ? this.#cuenta(new DOMParser().parseFromString(html, 'text/html')) : null;
        }

        #sustituirCabecera(html) {
          const actual = document.querySelector('a[data-carrito-cabecera]');
          if (!html || !actual) return;

          const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('a[data-carrito-cabecera]');
          if (!nuevo) return;

          const enfocado = document.activeElement === actual;
          const importado = document.importNode(nuevo, true);
          actual.replaceWith(importado);
          if (enfocado) importado.focus();
        }

        #mostrarError(texto) {
          const error = this.querySelector('[data-error-agregar]');
          if (error) error.textContent = texto;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinta-frases"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-cinta-frases')) {
    customElements.define(
      'delora-cinta-frases',
      class extends HTMLElement {
        #controlador;
        #mediaMovimiento;
        #pista;
        #boton;
        #clon;

        connectedCallback() {
          this.#pista = this.querySelector('.cinta-frases__pista');
          this.#boton = this.querySelector('.cinta-frases__pausa');
          if (!this.#pista || !this.#boton) return;

          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          this.#mediaMovimiento = matchMedia('(prefers-reduced-motion: reduce)');
          this.#mediaMovimiento.addEventListener('change', () => this.#actualizar(), { signal });
          this.#boton.addEventListener('click', () => this.#alternarPausa(), { signal });

          this.#actualizar();
        }

        disconnectedCallback() {
          this.#controlador?.abort();
        }

        #actualizar() {
          if (this.#mediaMovimiento.matches) {
            this.#desactivar();
          } else {
            this.#activar();
          }
        }

        #activar() {
          if (!this.#clon) {
            const lista = this.#pista.querySelector('.cinta-frases__lista');
            if (!lista) return;
            this.#clon = lista.cloneNode(true);
            this.#clon.setAttribute('aria-hidden', 'true');
            this.#clon.inert = true;
            this.#pista.append(this.#clon);
          }

          this.classList.add('cinta-frases__marco--animado');
          this.#boton.hidden = false;
        }

        #desactivar() {
          this.#clon?.remove();
          this.#clon = null;
          this.classList.remove('cinta-frases__marco--animado', 'cinta-frases__marco--pausado');
          this.#boton.hidden = true;
          this.#boton.setAttribute('aria-pressed', 'false');
        }

        #alternarPausa() {
          const pausado = this.classList.toggle('cinta-frases__marco--pausado');
          this.#boton.setAttribute('aria-pressed', String(pausado));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coleccion-destacada"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-coleccion-destacada')) {
    customElements.define(
      'delora-coleccion-destacada',
      class extends HTMLElement {
        #controlador;
        #peticion;
        #grilla;
        #estado;
        #grillaInicial;
        #columnas = '';
        #verTodo;
        #verTodoHref = '';

        connectedCallback() {
          this.#grilla = this.querySelector('[data-grilla]');
          this.#estado = this.querySelector('[data-estado]');
          if (!this.#grilla) return;

          this.#grillaInicial = this.#grilla.cloneNode(true);
          this.#columnas = this.#grilla.querySelector('.grilla-productos')?.style.getPropertyValue('--grilla-columnas') ?? '';

          const seccion = this.closest('.shopify-section');
          this.#verTodo = seccion?.querySelector('[data-ver-todo]') ?? null;
          this.#verTodoHref = this.#verTodo?.getAttribute('href') ?? '';

          this.#controlador = new AbortController();
          this.addEventListener('click', (evento) => this.#alPulsar(evento), { signal: this.#controlador.signal });
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#peticion?.abort();
        }

        #alPulsar(evento) {
          if (evento.defaultPrevented || evento.button !== 0) return;
          if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;

          const chip = evento.target.closest('a[data-familia]');
          if (!chip || !this.contains(chip)) return;

          evento.preventDefault();
          this.#peticion?.abort();

          if (chip.dataset.familia === '') {
            this.#peticion = undefined;
            this.#grilla.removeAttribute('aria-busy');
            this.#grilla.replaceChildren(...this.#grillaInicial.cloneNode(true).childNodes);
            this.#marcar(chip);
            this.#restaurarVerTodo();
            this.#anunciar(this.dataset.textoTodas ?? '');
            return;
          }

          this.#verTodo?.setAttribute('href', chip.href);
          this.#cargar(chip);
        }

        #restaurarVerTodo() {
          this.#verTodo?.setAttribute('href', this.#verTodoHref);
        }

        async #cargar(chip) {
          const peticion = new AbortController();
          this.#peticion = peticion;

          const url = new URL(chip.href, location.origin);
          url.searchParams.set('section_id', 'grilla-productos');
          this.#grilla.setAttribute('aria-busy', 'true');

          try {
            const respuesta = await fetch(url, { signal: peticion.signal });
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
            const html = await respuesta.text();
            peticion.signal.throwIfAborted();

            const documento = new DOMParser().parseFromString(html, 'text/html');
            const lista = documento.querySelector('ul.grilla-productos');

            if (lista) {
              const cantidad = Number(this.dataset.cantidad) || 0;
              for (const elemento of [...lista.children].slice(cantidad)) elemento.remove();
              if (this.#columnas) lista.style.setProperty('--grilla-columnas', this.#columnas);
              this.#grilla.replaceChildren(document.importNode(lista, true));
              this.#marcar(chip);
              const mostrados = lista.children.length;
              const plantilla = mostrados === 1 ? this.dataset.textoEstadoUno : this.dataset.textoEstadoOtros;
              this.#anunciar(
                (plantilla ?? '')
                  .replace('[cantidad]', String(mostrados))
                  .replace('[familia]', chip.dataset.familia)
              );
              return;
            }

            const vacio = documento.querySelector('.grilla-productos-api__vacio');
            if (!vacio) throw new Error('Respuesta sin grilla');

            this.#grilla.replaceChildren(document.importNode(vacio, true));
            this.#marcar(chip);
            this.#anunciar(vacio.textContent.trim());
          } catch (error) {
            if (error.name === 'AbortError') return;
            location.assign(chip.href);
          } finally {
            if (this.#peticion === peticion) {
              this.#peticion = undefined;
              this.#grilla.removeAttribute('aria-busy');
            }
          }
        }

        #marcar(chip) {
          for (const enlace of this.querySelectorAll('a[data-familia]')) {
            if (enlace === chip) {
              enlace.setAttribute('aria-current', 'true');
            } else {
              enlace.removeAttribute('aria-current');
            }
          }
        }

        #anunciar(texto) {
          if (this.#estado) this.#estado.textContent = texto;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explorador-notas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-explorador-notas')) {
    customElements.define(
      'delora-explorador-notas',
      class extends HTMLElement {
        #controlador;
        #peticion;
        #grilla;
        #contenedor;
        #estado;
        #verContenedor;
        #ver;
        #inicial = [];
        #activa = null;

        connectedCallback() {
          this.#grilla = this.querySelector('[data-lista]');
          this.#contenedor = this.querySelector('[data-grilla]');
          this.#estado = this.querySelector('[data-estado]');
          this.#verContenedor = this.querySelector('[data-ver-contenedor]');
          this.#ver = this.querySelector('[data-ver]');
          if (!this.#grilla) return;

          this.#inicial = [...this.#grilla.children].map((elemento) => elemento.cloneNode(true));

          this.#controlador = new AbortController();
          const señal = this.#controlador.signal;

          for (const enlace of this.querySelectorAll('a[data-nota]')) {
            enlace.setAttribute('role', 'button');
            enlace.setAttribute('aria-pressed', 'false');
          }

          this.addEventListener(
            'click',
            (evento) => {
              const chip = evento.target.closest('a[data-nota]');
              if (!chip || !this.contains(chip)) return;
              if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
              evento.preventDefault();
              this.#alternar(chip);
            },
            { signal: señal }
          );

          this.addEventListener(
            'keydown',
            (evento) => {
              if (evento.repeat) return;
              if (evento.code !== 'Space') return;
              const chip = evento.target.closest('a[data-nota]');
              if (!chip || !this.contains(chip)) return;
              evento.preventDefault();
              chip.click();
            },
            { signal: señal }
          );
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#peticion?.abort();
        }

        async #alternar(chip) {
          const nota = chip.dataset.nota;

          if (nota === this.#activa) {
            this.#restaurar();
            return;
          }

          this.#peticion?.abort();
          const peticion = new AbortController();
          this.#peticion = peticion;
          this.#contenedor?.setAttribute('aria-busy', 'true');

          const url = new URL(this.dataset.urlColeccion, location.origin);
          url.searchParams.set('filter.p.m.delora.notas', nota);
          url.searchParams.set('section_id', 'grilla-productos');

          try {
            const respuesta = await fetch(url, { signal: peticion.signal });
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
            const html = await respuesta.text();
            peticion.signal.throwIfAborted();

            const documento = new DOMParser().parseFromString(html, 'text/html');
            const contenedorRespuesta = documento.querySelector('[data-total]');
            if (!contenedorRespuesta) throw new Error('Respuesta sin grilla');
            const total = Number(contenedorRespuesta.dataset.total) || 0;
            const cantidad = Number(this.dataset.cantidad) || 0;
            const tarjetas = [...documento.querySelectorAll('li.grilla-productos__elemento')].slice(0, cantidad);

            if (tarjetas.length > 0) {
              this.#grilla.replaceChildren(...tarjetas.map((tarjeta) => document.importNode(tarjeta, true)));
            } else {
              const vacio = documento.querySelector('.grilla-productos-api__vacio');
              const elemento = document.createElement('li');
              if (vacio) elemento.append(document.importNode(vacio, true));
              this.#grilla.replaceChildren(elemento);
            }

            this.#marcar(chip);

            const plantilla = total === 1 ? this.dataset.textoUna : this.dataset.textoVarias;
            this.#anunciar(
              (plantilla ?? '').replace('[nota]', nota).replace('[cantidad]', String(total))
            );

            if (total > cantidad) {
              this.#ver?.setAttribute('href', chip.href);
              if (this.#ver) {
                this.#ver.textContent = (this.dataset.textoVer ?? '')
                  .replace('[nota]', nota)
                  .replace('[cantidad]', String(total));
              }
              if (this.#verContenedor) this.#verContenedor.hidden = false;
            } else if (this.#verContenedor) {
              this.#verContenedor.hidden = true;
            }

            this.#activa = nota;
          } catch (error) {
            if (error.name === 'AbortError') return;
            console.error(error);
            location.assign(chip.href);
          } finally {
            if (this.#peticion === peticion) {
              this.#peticion = undefined;
              this.#contenedor?.removeAttribute('aria-busy');
            }
          }
        }

        #restaurar() {
          this.#peticion?.abort();
          this.#peticion = undefined;
          this.#contenedor?.removeAttribute('aria-busy');
          this.#grilla.replaceChildren(...this.#inicial.map((elemento) => elemento.cloneNode(true)));
          for (const enlace of this.querySelectorAll('a[data-nota]')) {
            enlace.setAttribute('aria-pressed', 'false');
          }
          this.#anunciar('');
          if (this.#verContenedor) this.#verContenedor.hidden = true;
          this.#activa = null;
        }

        #marcar(chip) {
          for (const enlace of this.querySelectorAll('a[data-nota]')) {
            enlace.setAttribute('aria-pressed', enlace === chip ? 'true' : 'false');
          }
        }

        #anunciar(texto) {
          if (this.#estado) this.#estado.textContent = texto;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carrusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-hero-carrusel')) {
    customElements.define(
      'delora-hero-carrusel',
      class extends HTMLElement {
        #controlador;
        #observador;
        #temporizador;
        #mediaMovimiento;
        #pista;
        #controles;
        #botonPausa;
        #diapositivas = [];
        #puntos = [];
        #actual = 0;
        #pausadoPorBoton = false;
        #sobreMarco = false;
        #conFoco = false;

        connectedCallback() {
          this.#pista = this.querySelector('.hero-carrusel__pista');
          this.#controles = this.querySelector('.hero-carrusel__controles');
          if (!this.#pista || !this.#controles) return;

          this.#diapositivas = [...this.#pista.querySelectorAll(':scope > [data-diapositiva]')];
          if (this.#diapositivas.length < 2) return;

          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          this.#prepararDiapositivas();
          this.#construirPuntos(signal);

          this.#botonPausa = this.#controles.querySelector('[data-pausa]');
          this.#controles.querySelector('[data-anterior]')?.addEventListener('click', () => this.#ir(this.#actual - 1), { signal });
          this.#controles.querySelector('[data-siguiente]')?.addEventListener('click', () => this.#ir(this.#actual + 1), { signal });
          this.#botonPausa?.addEventListener('click', () => this.#alternarPausa(), { signal });

          this.addEventListener(
            'pointerenter',
            () => {
              this.#sobreMarco = true;
              this.#actualizarAutoavance();
            },
            { signal }
          );
          this.addEventListener(
            'pointerleave',
            () => {
              this.#sobreMarco = false;
              this.#actualizarAutoavance();
            },
            { signal }
          );
          this.addEventListener(
            'focusin',
            () => {
              this.#conFoco = true;
              this.#actualizarAutoavance();
            },
            { signal }
          );
          this.addEventListener(
            'focusout',
            (evento) => {
              if (this.contains(evento.relatedTarget)) return;
              this.#conFoco = false;
              this.#actualizarAutoavance();
            },
            { signal }
          );
          document.addEventListener('visibilitychange', () => this.#actualizarAutoavance(), { signal });
          this.addEventListener(
            'shopify:block:select',
            (evento) => {
              const indice = this.#diapositivas.indexOf(evento.target.closest('[data-diapositiva]'));
              if (indice === -1) return;
              this.#marcarActiva(indice);
              this.#ir(indice);
            },
            { signal }
          );

          this.#mediaMovimiento = matchMedia('(prefers-reduced-motion: reduce)');
          this.#mediaMovimiento.addEventListener('change', () => this.#actualizarAutoavance(), { signal });

          this.#observador = new IntersectionObserver((entradas) => this.#alObservar(entradas), {
            root: this.#pista,
            threshold: 0.6,
          });
          for (const diapositiva of this.#diapositivas) this.#observador.observe(diapositiva);

          this.#marcarActiva(0);
          this.#controles.hidden = false;
          this.#actualizarAutoavance();
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#observador?.disconnect();
          clearInterval(this.#temporizador);
          this.#temporizador = undefined;
        }

        #prepararDiapositivas() {
          const total = String(this.#diapositivas.length);
          const plantilla = this.dataset.textoDiapositiva ?? '';

          for (const [indice, diapositiva] of this.#diapositivas.entries()) {
            diapositiva.setAttribute('role', 'group');
            diapositiva.setAttribute('aria-roledescription', this.dataset.textoRolDiapositiva ?? '');
            diapositiva.setAttribute('aria-label', plantilla.replace('[actual]', String(indice + 1)).replace('[total]', total));
          }
        }

        #construirPuntos(signal) {
          const contenedor = this.#controles.querySelector('.hero-carrusel__puntos');
          if (!contenedor) return;

          const plantilla = this.dataset.textoIrA ?? '';
          this.#puntos = [];

          for (const indice of this.#diapositivas.keys()) {
            const punto = document.createElement('button');
            punto.type = 'button';
            punto.className = 'hero-carrusel__punto';
            punto.setAttribute('aria-label', plantilla.replace('[numero]', String(indice + 1)));
            punto.addEventListener(
              'click',
              () => {
                this.#ir(indice);
                if (this.dataset.soloPuntos === 'true') this.#detenerPorUsuario();
              },
              { signal }
            );
            this.#puntos.push(punto);
          }

          contenedor.replaceChildren(...this.#puntos);
        }

        #alObservar(entradas) {
          for (const entrada of entradas) {
            if (!entrada.isIntersecting || entrada.intersectionRatio < 0.6) continue;
            const indice = this.#diapositivas.indexOf(entrada.target);
            if (indice !== -1) this.#marcarActiva(indice);
          }
        }

        #marcarActiva(indice) {
          this.#actual = indice;
          const enfocado = document.activeElement;
          let focoEnInerte = false;

          for (const [posicion, diapositiva] of this.#diapositivas.entries()) {
            const inerte = posicion !== indice;
            if (inerte && diapositiva.contains(enfocado)) focoEnInerte = true;

            for (const enfocable of diapositiva.querySelectorAll('a[href], button')) {
              enfocable.inert = inerte;
              if (inerte) enfocable.setAttribute('tabindex', '-1');
              else enfocable.removeAttribute('tabindex');
            }
          }

          for (const [posicion, punto] of this.#puntos.entries()) {
            if (posicion === indice) {
              punto.setAttribute('aria-current', 'true');
            } else {
              punto.removeAttribute('aria-current');
            }
          }

          if (focoEnInerte) this.#reubicarFoco(indice);
        }

        #reubicarFoco(indice) {
          const enfocable = this.#diapositivas[indice].querySelector(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          );
          const destino = enfocable ?? this.#controles.querySelector('[data-anterior]') ?? this.#puntos[indice];
          destino?.focus({ preventScroll: true });
        }

        #ir(indice) {
          const total = this.#diapositivas.length;
          this.#actual = (indice + total) % total;
          this.#pista.scrollTo({ left: this.#diapositivas[this.#actual].offsetLeft });
        }

        #alternarPausa() {
          this.#pausadoPorBoton = !this.#pausadoPorBoton;
          this.#reflejarPausa();
          this.#actualizarAutoavance();
        }

        // Sin botón de pausa, usar un punto detiene el autoavance: sigue habiendo una forma de pararlo (WCAG 2.2.2)
        #detenerPorUsuario() {
          if (this.#pausadoPorBoton) return;
          this.#pausadoPorBoton = true;
          this.#actualizarAutoavance();
        }

        #reflejarPausa() {
          this.#botonPausa?.setAttribute('aria-pressed', String(this.#pausadoPorBoton));
        }

        #actualizarAutoavance() {
          clearInterval(this.#temporizador);
          this.#temporizador = undefined;

          const disponible = this.dataset.autoavance === 'true' && !this.#mediaMovimiento?.matches;

          if (this.#botonPausa) {
            this.#botonPausa.hidden = !disponible;
            if (!disponible && this.#pausadoPorBoton) {
              this.#pausadoPorBoton = false;
              this.#reflejarPausa();
            }
          }

          const detenido =
            window.Shopify?.designMode || this.#pausadoPorBoton || this.#sobreMarco || this.#conFoco || document.hidden;

          if (disponible && !detenido) {
            const segundos = Number(this.dataset.segundos) || 7;
            this.#temporizador = setInterval(() => this.#ir(this.#actual + 1), segundos * 1000);
          }

          this.#pista.setAttribute('aria-live', this.#temporizador ? 'off' : 'polite');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (() => {
    const mensaje = document.getElementById(location.hash.slice(1))?.querySelector('.contrasena__boletin-mensaje');
    if (!mensaje) return;

    // Mismo patrón que sections/boletin.liquid: el navegador desplaza a la
    // sección con el fragmento de la URL y, como su destino no es enfocable
    // (el <form>), a veces quita el foco puesto por script poco después. Se
    // reafirma una sola vez, solo si esa es la firma exacta del reinicio del
    // navegador (sin relatedTarget y a <body>), nunca si el foco se movió a
    // otro elemento. El listener se desarma al segundo.
    const controlEnfoque = new AbortController();
    mensaje.focus();
    mensaje.addEventListener(
      'focusout',
      (evento) => {
        if (!evento.relatedTarget && document.activeElement === document.body) {
          mensaje.focus();
        }
      },
      { once: true, signal: controlEnfoque.signal }
    );
    setTimeout(() => controlEnfoque.abort(), 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["producto-principal"]) return;
  try {
    
  if (!customElements.get('delora-producto')) {
    customElements.define(
      'delora-producto',
      class extends HTMLElement {
        #controlador;
        #peticion;

        connectedCallback() {
          this.#controlador?.abort();
          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          this.#habilitarFocoEnAgotados();
          this.addEventListener('change', (evento) => this.#alCambiar(evento), { signal });
          this.addEventListener('click', (evento) => this.#alPulsar(evento), { signal });
          this.addEventListener('mousedown', (evento) => this.#alPresionar(evento), { signal });
          this.#observarLista(signal);

          const activa = this.querySelector('[data-galeria]')?.dataset.imagenActiva;
          if (activa) this.#mostrarImagen(activa, false);
          else this.#sincronizarMiniaturas();
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#peticion?.abort();
        }

        #lista() {
          return this.querySelector('[data-imagenes]');
        }

        // Los radios de tamaño agotados llegan `disabled` del servidor (sin JS, siguen así). Con
        // JS se cambia por `aria-disabled` para que sigan siendo enfocables y el lector de
        // pantalla anuncie «(Agotado)»; el botón de comprar sigue usando `disabled`.
        #habilitarFocoEnAgotados() {
          for (const radio of this.querySelectorAll('.producto-principal__tamanos input[type="radio"][disabled]')) {
            radio.disabled = false;
            radio.setAttribute('aria-disabled', 'true');
          }
        }

        #observarLista(signal) {
          const lista = this.#lista();
          if (!lista) return;

          if ('onscrollend' in window) {
            lista.addEventListener('scrollend', () => this.#sincronizarMiniaturas(), { signal });
            return;
          }

          let espera = 0;
          const sincronizar = () => {
            clearTimeout(espera);
            espera = setTimeout(() => this.#sincronizarMiniaturas(), 100);
          };
          lista.addEventListener('scroll', sincronizar, { passive: true, signal });
          signal.addEventListener('abort', () => clearTimeout(espera), { once: true });
        }

        #alCambiar(evento) {
          const campo = evento.target;
          if (!(campo instanceof HTMLInputElement) && !(campo instanceof HTMLSelectElement)) return;
          if (campo.name !== 'id' || !campo.closest('[data-formulario]')) return;
          if (campo instanceof HTMLInputElement && !campo.checked) return;

          this.#actualizar(campo.value);
        }

        // Con el ratón o el dedo, enfocar la miniatura no desplaza la página; con Tab sigue desplazando (`mousedown`: `pointerdown` no evita el foco)
        #alPresionar(evento) {
          if (evento.button !== 0 || !(evento.target instanceof Element)) return;
          const miniatura = evento.target.closest('[data-miniatura]');
          if (!miniatura) return;

          evento.preventDefault();
          miniatura.focus({ preventScroll: true });
        }

        #alPulsar(evento) {
          if (evento.defaultPrevented || evento.button !== 0) return;
          if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
          if (!(evento.target instanceof Element)) return;

          const miniatura = evento.target.closest('[data-miniatura]');
          if (miniatura) {
            evento.preventDefault();
            this.#mostrarImagen(miniatura.dataset.miniatura);
            return;
          }

          const volver = evento.target.closest('[data-volver]');
          if (volver) this.#volver(evento, volver);
        }

        #volver(evento, enlace) {
          const navegacion = window.navigation;
          const actual = navegacion?.currentEntry;
          if (!actual || !('sameDocument' in actual)) {
            if (!this.#puedeVolver()) return;
            evento.preventDefault();
            window.history.back();
            return;
          }

          const entradas = navegacion.entries();
          let indice = actual.index - 1;
          while (indice >= 0 && entradas[indice].sameDocument) indice -= 1;
          const entrada = entradas[indice];
          if (!entrada || !this.#esListado(entrada.url)) return;

          evento.preventDefault();
          const { committed, finished } = navegacion.traverseTo(entrada.key);
          finished.catch(() => {});
          committed.catch((error) => {
            if (error?.name !== 'AbortError') window.location.assign(enlace.href);
          });
        }

        #puedeVolver() {
          if (window.history.length < 2 || !document.referrer) return false;
          try {
            return new URL(document.referrer).origin === window.location.origin && this.#esListado(document.referrer);
          } catch {
            return false;
          }
        }

        // Portada, colección (con etiqueta) o búsqueda, con el prefijo de idioma opcional de `transicion-paginas`: /es, /en-us, /es-419
        #esListado(url) {
          try {
            const ruta = new URL(url, window.location.href).pathname;
            if (ruta.includes('/products/')) return false;
            return /^(?:\/[a-z]{2,3}(?:-[a-z0-9]{2,4})?)?(?:\/collections\/[^/]+(?:\/[^/]+)?|\/search)?\/?$/i.test(ruta);
          } catch {
            return false;
          }
        }

        async #actualizar(idVariante) {
          this.#peticion?.abort();
          const peticion = new AbortController();
          this.#peticion = peticion;

          const destino = new URL(window.location.href);
          destino.searchParams.set('variant', idVariante);
          destino.hash = '';

          const pedido = new URL(this.dataset.url, window.location.href);
          pedido.searchParams.set('variant', idVariante);
          pedido.searchParams.set('section_id', this.dataset.seccion);

          try {
            const respuesta = await fetch(pedido, { signal: peticion.signal });
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);

            const html = await respuesta.text();
            if (peticion.signal.aborted) return;

            const documento = new DOMParser().parseFromString(html, 'text/html');
            this.#sustituirRegiones(documento);
            window.history.replaceState(window.history.state, '', destino.href);

            const galeria = this.querySelector('[data-galeria]');
            const imagen = documento.querySelector('[data-galeria]')?.dataset.imagenActiva;
            if (galeria && imagen && imagen !== galeria.dataset.imagenActiva) {
              galeria.dataset.imagenActiva = imagen;
              this.#mostrarImagen(imagen);
            }

            this.#anunciar();
          } catch (error) {
            if (peticion.signal.aborted || error?.name === 'AbortError') return;
            window.location.assign(destino.href);
          } finally {
            if (this.#peticion === peticion) this.#peticion = null;
          }
        }

        #sustituirRegiones(documento) {
          for (const region of this.querySelectorAll('[data-region]')) {
            const nueva = documento.querySelector(`[data-region="${CSS.escape(region.dataset.region)}"]`);
            if (nueva) region.replaceWith(document.importNode(nueva, true));
          }
        }

        #mostrarImagen(id, suave = true) {
          const lista = this.#lista();
          const diapositiva = id ? lista?.querySelector(`[data-imagen="${CSS.escape(id)}"]`) : null;
          if (!lista || !diapositiva) return;

          const izquierda =
            lista.scrollLeft + diapositiva.getBoundingClientRect().left - lista.getBoundingClientRect().left;
          const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          lista.scrollTo({ left: izquierda, behavior: suave && !reducido ? 'smooth' : 'instant' });
          this.#marcarMiniatura(id);
        }

        #sincronizarMiniaturas() {
          const lista = this.#lista();
          if (!lista || lista.clientWidth === 0) return;

          const indice = Math.round(Math.abs(lista.scrollLeft) / lista.clientWidth);
          const diapositiva = lista.children[indice];
          if (diapositiva instanceof HTMLElement) this.#marcarMiniatura(diapositiva.dataset.imagen);
        }

        #marcarMiniatura(id) {
          for (const miniatura of this.querySelectorAll('[data-miniatura]')) {
            if (miniatura.dataset.miniatura === id) miniatura.setAttribute('aria-current', 'true');
            else miniatura.removeAttribute('aria-current');
          }
        }

        #anunciar() {
          const estado = this.querySelector('[data-estado]');
          const precio = this.querySelector('[data-region="precio"] .precio__actual');
          if (!estado || !precio) return;

          const partes = [(estado.dataset.texto ?? '').replace('[precio]', precio.textContent.trim())];
          const comprar = this.querySelector('[data-region="comprar"]');
          if (comprar instanceof HTMLButtonElement && comprar.disabled) partes.push(comprar.textContent.trim());
          const stock = this.querySelector('[data-region="stock"]')?.textContent.trim();
          if (stock) partes.push(stock);
          estado.textContent = partes.join(' · ');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recomendaciones"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('delora-recomendaciones')) {
    customElements.define(
      'delora-recomendaciones',
      class extends HTMLElement {
        #controlador;
        #observador;

        connectedCallback() {
          const seccion = this.closest('.shopify-section');
          if (!seccion) return;

          this.#controlador = new AbortController();
          this.#observador = new IntersectionObserver((entradas) => this.#alObservar(entradas), {
            rootMargin: '0px 0px 400px 0px',
          });
          this.#observador.observe(seccion);
        }

        disconnectedCallback() {
          this.#observador?.disconnect();
          this.#controlador?.abort();
        }

        #alObservar(entradas) {
          if (!entradas[0]?.isIntersecting) return;
          this.#observador.disconnect();
          this.#cargar();
        }

        async #cargar() {
          const url = this.dataset.url;
          if (!url) return;

          try {
            const origen = (await this.#pedir(url)).querySelector('delora-recomendaciones');
            if (!origen) return;

            if (origen.querySelectorAll('li.grilla-productos__elemento').length > 0) {
              this.#mostrar(document.importNode(origen, true).childNodes);
              return;
            }

            const plantilla = origen.querySelector('template[data-respaldo]');
            if (plantilla) await this.#respaldo(plantilla);
          } catch (error) {
            if (error.name === 'AbortError') return;
            console.error(error);
          }
        }

        async #pedir(url) {
          const respuesta = await fetch(url, { signal: this.#controlador.signal });
          if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
          const html = await respuesta.text();
          this.#controlador.signal.throwIfAborted();
          return new DOMParser().parseFromString(html, 'text/html');
        }

        // Sin recomendaciones de Shopify: fragancias de sus familias, en orden, y si faltan, de su marca
        async #respaldo(plantilla) {
          const cantidad = Number(this.dataset.cantidad) || 0;
          const coleccion = this.dataset.urlColeccion;
          if (cantidad < 1 || !coleccion) return;

          const filtros = this.#familias().map((familia) => ['filter.p.m.delora.familia', familia]);
          if (this.dataset.marca) filtros.push(['filter.p.vendor', this.dataset.marca]);

          const vistas = new Set(this.dataset.producto ? [this.#ruta(this.dataset.producto)] : []);
          const tarjetas = [];
          for (const filtro of filtros) {
            if (tarjetas.length >= cantidad) break;

            const url = new URL(coleccion, location.origin);
            url.search = new URLSearchParams([filtro, ['section_id', 'grilla-productos']]).toString();
            const documento = await this.#pedir(url);
            for (const elemento of documento.querySelectorAll('ul.grilla-productos > li')) {
              const ruta = this.#ruta(elemento.querySelector('a[href]')?.getAttribute('href'));
              if (!ruta || vistas.has(ruta) || tarjetas.length >= cantidad) continue;
              vistas.add(ruta);
              tarjetas.push(document.importNode(elemento, true));
            }
          }
          if (tarjetas.length === 0) return;

          const contenido = document.importNode(plantilla.content, true);
          const lista = contenido.querySelector('ul.grilla-productos');
          if (!lista) return;
          lista.append(...tarjetas);
          this.#mostrar(contenido.childNodes);
        }

        #familias() {
          try {
            const familias = JSON.parse(this.dataset.familias || '[]');
            return Array.isArray(familias) ? familias.filter((familia) => typeof familia === 'string' && familia !== '') : [];
          } catch {
            return [];
          }
        }

        #ruta(href) {
          if (!href) return '';
          try {
            return new URL(href, location.origin).pathname;
          } catch {
            return '';
          }
        }

        #mostrar(nodos) {
          this.replaceChildren(...nodos);
          this.closest('.recomendaciones')?.removeAttribute('hidden');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
